import React from 'react';
import { Helmet } from 'react-helmet-async';

interface IHeadProps {
  title?: string;
  description?: string;
}

const Head = ({ title, description }: IHeadProps) => {
  return (
    <Helmet>
      {title ? <title>{title}</title> : <title>Rentistic</title>}
      {description ? <meta name="description" content={description} /> : null}
    </Helmet>
  );
};

export default Head;
